




























import { Vue, Component } from "vue-property-decorator";
import axios from "axios";

interface UrlStats {
    url: string;
    total_time: number;
    avg_time: number;
}

interface LogData {
    top_by_total_time: UrlStats[];
    top_by_avg_time: UrlStats[];
}

interface ServerInfo {
    name: string;
    filePath: string;
}

@Component({})
export default class LogStats extends Vue {
    servers: ServerInfo[] = [
        { name: "Караганда", filePath: "/var/log/nginx/access_krg_mcsikz.log" },
        { name: "Актобе", filePath: "/var/log/nginx/access_atb_csikz.log" },
        { name: "Павлодар", filePath: "/var/log/nginx/access_pavl_csikz.log" },
        { name: "Акмола", filePath: "/var/log/nginx/access_aqm_csikz.log" },
        { name: "Алматы", filePath: "/var/log/nginx/access_alma_csikz.log" },
        { name: "Мангистау", filePath: "/var/log/nginx/access_mang_csikz.log" },
        { name: "Абай", filePath: "/var/log/nginx/access_abai_csikz.log" },
        { name: "Улытау", filePath: "/var/log/nginx/access_uly_csikz.log" },
        { name: "СКО", filePath: "/var/log/nginx/access_sko_csikz.log" },
        { name: "ЗКО", filePath: "/var/log/nginx/access_zko_csikz.log" },
        { name: "Конаев", filePath: "/var/log/nginx/access_kon_csikz.log" },
        { name: "КЗО", filePath: "/var/log/nginx/access_kzo_csikz.log" },
        { name: "ВКО", filePath: "/var/log/nginx/access_vkoo_csikz.log" },
        { name: "Караганда релиз", filePath: "/var/log/nginx/access_krg_relkz.log" },

    ];

    logData: Map<string, LogData | null> = new Map();
    loading: boolean = false;
    errorMessage: string = "";

    fields = [
        { key: "total_time", label: "Общее время (сек)" },
        { key: "avg_time", label: "Среднее время (сек)" },
        { key: "url", label: "URL" },
    ];

    async fetchLogData(server: ServerInfo) {
        this.loading = true;
        this.errorMessage = "";
        this.logData.set(server.name, null);

        try {
            const response = await fetch(`/rust-api/analyze?file=${encodeURIComponent(server.filePath)}`);
            const result = await response.json();
            // const response = await axios.get<LogData>(`/api-rust/analyze?file=${encodeURIComponent(server.filePath)}`);
            this.logData.set(server.name, result);
            for (const resultElement of result.top_by_avg_time) {
               resultElement.url = decodeURIComponent(resultElement.url);
            }
            for (const resultElement of result.top_by_total_time) {
                resultElement.url = decodeURIComponent(resultElement.url);
            }
            for (const resultElement of result.top_by_avg_time_last_hour) {
                resultElement.url = decodeURIComponent(resultElement.url);
            }
            // this.$set(this.logData, server.name, result);
        } catch (error) {
            this.errorMessage = `Ошибка загрузки данных для ${server.name}!`;
            console.error(`Ошибка запроса для ${server.name}:`, error);
        } finally {
            this.loading = false;
        }
    }

    mounted() {
        this.servers.forEach((server) => this.fetchLogData(server));
    }
}
